import { render, staticRenderFns } from "./HeroField.vue?vue&type=template&id=73d6810e"
import script from "./HeroField.vue?vue&type=script&lang=js"
export * from "./HeroField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports